var _classCallCheck = require("/codebuild/output/src1039780453/src/web/node_modules/@babel/runtime/helpers/classCallCheck.js");

var _createClass = require("/codebuild/output/src1039780453/src/web/node_modules/@babel/runtime/helpers/createClass.js");

var _get = require("/codebuild/output/src1039780453/src/web/node_modules/@babel/runtime/helpers/get.js");

var _inherits = require("/codebuild/output/src1039780453/src/web/node_modules/@babel/runtime/helpers/inherits.js");

var _possibleConstructorReturn = require("/codebuild/output/src1039780453/src/web/node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");

var _getPrototypeOf = require("/codebuild/output/src1039780453/src/web/node_modules/@babel/runtime/helpers/getPrototypeOf.js");

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var Prefixer = require('./prefixer');

var Browsers = require('./browsers');

var utils = require('./utils');

var Declaration = /*#__PURE__*/function (_Prefixer) {
  "use strict";

  _inherits(Declaration, _Prefixer);

  var _super = _createSuper(Declaration);

  function Declaration() {
    _classCallCheck(this, Declaration);

    return _super.apply(this, arguments);
  }

  _createClass(Declaration, [{
    key: "check",
    value:
    /**
     * Always true, because we already get prefixer by property name
     */
    function
      /* decl */
    check() {
      return true;
    }
    /**
     * Return prefixed version of property
     */

  }, {
    key: "prefixed",
    value: function prefixed(prop, prefix) {
      return prefix + prop;
    }
    /**
     * Return unprefixed version of property
     */

  }, {
    key: "normalize",
    value: function normalize(prop) {
      return prop;
    }
    /**
     * Check `value`, that it contain other prefixes, rather than `prefix`
     */

  }, {
    key: "otherPrefixes",
    value: function otherPrefixes(value, prefix) {
      var _iterator = _createForOfIteratorHelper(Browsers.prefixes()),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var other = _step.value;

          if (other === prefix) {
            continue;
          }

          if (value.includes(other)) {
            return true;
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      return false;
    }
    /**
     * Set prefix to declaration
     */

  }, {
    key: "set",
    value: function set(decl, prefix) {
      decl.prop = this.prefixed(decl.prop, prefix);
      return decl;
    }
    /**
     * Should we use visual cascade for prefixes
     */

  }, {
    key: "needCascade",
    value: function needCascade(decl) {
      if (!decl._autoprefixerCascade) {
        decl._autoprefixerCascade = this.all.options.cascade !== false && decl.raw('before').includes('\n');
      }

      return decl._autoprefixerCascade;
    }
    /**
     * Return maximum length of possible prefixed property
     */

  }, {
    key: "maxPrefixed",
    value: function maxPrefixed(prefixes, decl) {
      if (decl._autoprefixerMax) {
        return decl._autoprefixerMax;
      }

      var max = 0;

      var _iterator2 = _createForOfIteratorHelper(prefixes),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var prefix = _step2.value;
          prefix = utils.removeNote(prefix);

          if (prefix.length > max) {
            max = prefix.length;
          }
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }

      decl._autoprefixerMax = max;
      return decl._autoprefixerMax;
    }
    /**
     * Calculate indentation to create visual cascade
     */

  }, {
    key: "calcBefore",
    value: function calcBefore(prefixes, decl) {
      var prefix = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
      var max = this.maxPrefixed(prefixes, decl);
      var diff = max - utils.removeNote(prefix).length;
      var before = decl.raw('before');

      if (diff > 0) {
        before += Array(diff).fill(' ').join('');
      }

      return before;
    }
    /**
     * Remove visual cascade
     */

  }, {
    key: "restoreBefore",
    value: function restoreBefore(decl) {
      var lines = decl.raw('before').split('\n');
      var min = lines[lines.length - 1];
      this.all.group(decl).up(function (prefixed) {
        var array = prefixed.raw('before').split('\n');
        var last = array[array.length - 1];

        if (last.length < min.length) {
          min = last;
        }
      });
      lines[lines.length - 1] = min;
      decl.raws.before = lines.join('\n');
    }
    /**
     * Clone and insert new declaration
     */

  }, {
    key: "insert",
    value: function insert(decl, prefix, prefixes) {
      var cloned = this.set(this.clone(decl), prefix);
      if (!cloned) return undefined;
      var already = decl.parent.some(function (i) {
        return i.prop === cloned.prop && i.value === cloned.value;
      });

      if (already) {
        return undefined;
      }

      if (this.needCascade(decl)) {
        cloned.raws.before = this.calcBefore(prefixes, decl, prefix);
      }

      return decl.parent.insertBefore(decl, cloned);
    }
    /**
     * Did this declaration has this prefix above
     */

  }, {
    key: "isAlready",
    value: function isAlready(decl, prefixed) {
      var already = this.all.group(decl).up(function (i) {
        return i.prop === prefixed;
      });

      if (!already) {
        already = this.all.group(decl).down(function (i) {
          return i.prop === prefixed;
        });
      }

      return already;
    }
    /**
     * Clone and add prefixes for declaration
     */

  }, {
    key: "add",
    value: function add(decl, prefix, prefixes, result) {
      var prefixed = this.prefixed(decl.prop, prefix);

      if (this.isAlready(decl, prefixed) || this.otherPrefixes(decl.value, prefix)) {
        return undefined;
      }

      return this.insert(decl, prefix, prefixes, result);
    }
    /**
     * Add spaces for visual cascade
     */

  }, {
    key: "process",
    value: function process(decl, result) {
      if (!this.needCascade(decl)) {
        _get(_getPrototypeOf(Declaration.prototype), "process", this).call(this, decl, result);

        return;
      }

      var prefixes = _get(_getPrototypeOf(Declaration.prototype), "process", this).call(this, decl, result);

      if (!prefixes || !prefixes.length) {
        return;
      }

      this.restoreBefore(decl);
      decl.raws.before = this.calcBefore(prefixes, decl);
    }
    /**
     * Return list of prefixed properties to clean old prefixes
     */

  }, {
    key: "old",
    value: function old(prop, prefix) {
      return [this.prefixed(prop, prefix)];
    }
  }]);

  return Declaration;
}(Prefixer);

module.exports = Declaration;